module.exports = __webpack_public_path__ + "img/reju1.d84955be.png";